import * as core from '../../../../../../../core'
import * as attainSpecKit from '../attain-spec-kit'

export const RESOURCE = {
  payload: {
    alias: 'planning',
    appAlias: attainSpecKit.RESOURCE.payload.alias,
    description:
      'Browse the engagement charter components planned for this engagement',
    display: {
      isMain: true,
      position: 0,
    },
    name: 'Planning',
    page: { alias: 'planning' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
